import { api, getApiErrorMessage } from './api';

function request(method, url, config = {}, data) {
  return api.request({
    ...config,
    method,
    url,
    data,
  });
}

export const internalAgentApi = {
  get(url, config = {}) {
    return request('get', url, config);
  },
  post(url, data, config = {}) {
    return request('post', url, config, data);
  },
  patch(url, data, config = {}) {
    return request('patch', url, config, data);
  },
};

export function getInternalAgentErrorMessage(error, fallback = 'Request failed') {
  const status = error?.response?.status;
  const detail = String(error?.response?.data?.detail || '').trim();
  if (status === 401) {
    if (/default firebase app does not exist|initialize_app/i.test(detail)) {
      return 'Authentication service is starting up. Please retry in a moment.';
    }
    if (/missing bearer token/i.test(detail)) {
      return 'Session is still initializing. Retry in a moment.';
    }
  }
  if (status === 403) {
    return 'Signed in account is not authorized for this internal route.';
  }
  return getApiErrorMessage(error, fallback);
}
